var _style, _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "close_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 1024 1024"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E30613",
    d: "M866.4 156.1c-.9-1.1-2-2.1-3-3l3 3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#F9AF17",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 65,
    d: "M764.5 259.5l-505 505M764.5 764.5l-505-505"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M773.5 161.1v2.7h-1.1v-3.6c-18.8-14.1-38.8-26.8-59.6-37.6-30.3-15.8-62.5-28-95.7-36.3C583 77.9 547.6 73.6 512 73.6c-58.7 0-115.6 11.5-169.1 34.1-51.7 21.9-98.2 53.2-138.1 93.2-39.9 39.9-71.3 86.4-93.2 138.1C89 392.6 77.5 449.5 77.5 508.2S89 623.8 111.6 677.3c21.9 51.7 53.2 98.2 93.2 138.1 39.9 39.9 86.4 71.3 138.1 93.2 53.5 22.6 110.4 34.1 169.1 34.1s115.6-11.5 169.1-34.1c51.7-21.9 98.2-53.2 138.1-93.2 39.9-39.9 71.3-86.4 93.2-138.1 22.6-53.5 34.1-110.4 34.1-169.1 0-46.6-7.3-92.4-21.7-136.2-14-42.3-34.3-82.2-60.6-118.4-1.4-2-2.9-3.9-4.3-5.8-.6-.7-1.1-1.4-1.6-2.1-24.2-31.9-52.9-60.4-84.8-84.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#35A4DD",
    d: "M512 77.5c58.7 0 115.6 11.5 169.1 34.1 51.7 21.9 98.2 53.2 138.1 93.2 39.9 39.9 71.3 86.4 93.2 138.1 22.6 53.5 34.1 110.4 34.1 169.1S935 627.6 912.4 681.1c-21.9 51.7-53.2 98.2-93.2 138.1-39.9 39.9-86.4 71.3-138.1 93.2-53.5 22.6-110.4 34.1-169.1 34.1S396.4 935 342.9 912.4c-51.7-21.9-98.2-53.2-138.1-93.2-39.9-39.9-71.3-86.4-93.2-138.1C88.9 627.6 77.4 570.7 77.4 512s11.5-115.6 34.1-169.1c21.9-51.7 53.2-98.2 93.2-138.1 39.9-39.9 86.4-71.3 138.1-93.2C396.4 88.9 453.3 77.5 512 77.5m0-65C236.1 12.5 12.4 236.1 12.4 512s223.7 499.5 499.6 499.5 499.6-223.7 499.6-499.5S787.9 12.5 512 12.5z"
  })));
}

export default SvgClose;